module.exports = __webpack_public_path__ + "static/Darrick Rochili-762dd08504c197c12846f8eeca4d9b4d.jpg";